import { render, staticRenderFns } from "./Procesos.vue?vue&type=template&id=dcd003c8&scoped=true"
import script from "./Procesos.vue?vue&type=script&lang=js"
export * from "./Procesos.vue?vue&type=script&lang=js"
import style0 from "./Procesos.vue?vue&type=style&index=0&id=dcd003c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd003c8",
  null
  
)

export default component.exports